// extracted by mini-css-extract-plugin
module.exports = {"treebank":"App_treebank__1HXOr","graph":"App_graph__2vjHC","textarea":"App_textarea__3kHMA"};